<template>
    <div class="calendar">
        <v-date-picker
            mode='range'
            :attributes="attrs"
            :theme-styles='themeStyles'
            v-model="selectedDate"
            :input-props='{ class: "input", placeholder: "Enter days range", readonly: true }'
            :popover-visibility="popoverVisibility">
            </v-date-picker>
    </div>
</template>
<script>
import Vue from "vue"
import VCalendar from 'v-calendar';
import 'v-calendar/lib/v-calendar.min.css';
import moment from 'moment'

Vue.use(moment)

Vue.use(VCalendar)
export default {
    name: 'datepicker',
    watch: {
        selectedDate() {
            this.selectDate()
        }
    },
    data() {
        return {
            dates: [],
            selectedDate: null,
            popoverVisibility: 'focus',
            themeStyles: { // calendar main styling, other styles are in scss
                wrapper: {
                    background: '#ffffff',
                    color: '#4A4A4A',
                    fontWeight: '700'
                }
            },
            attrs: [
                {
                    popover: null,
                    key: 'today',
                    highlight: {
                        backgroundColor: '#1FA4DB',
                    },
                    contentStyle: {
                        color: '#fff',
                    },
                }
            ]
        }
    },
    mounted: function(){
    },
    methods: {
        selectDate:function() {
            this.$emit('rangeSelected', this.selectedDate)
        }
    }
}
</script>